export const environment = {
  apiBaseUri: 'https://func-convergent-dev-purview-api.azurewebsites.net/api',
  /**
   * This provide the base url for all the end points protected by the APIM.
   * by 10/2024 only the carefindr provider and facility search are fronted by the APIM.
   */
  apimOverrideUri: 'https://api-test.getconvergent.io/carefindr/apim2',
  apimOverrideUriV2: 'https://api-test.getconvergent.io/carefindr/apim3',
  apiV2BaseUri: 'https://convergent-dev-carefindr-func.azurewebsites.net/api'
};
